const FbWhite = '/assets/svg/fb-white-bg.svg';
const LinkedinWhite = '/assets/svg/linkedin-white-bg.svg';
const InstagramWhite = '/assets/svg/insta-white-bg.svg';
const TikTokWhite = '/assets/svg/tiktok-white-bg.svg';
const Fb = '/assets/svg/fb.svg';
const Linkedin = '/assets/svg/linkdin.svg';
const Instagram = '/assets/svg/insta.svg';
const TikTok = '/assets/svg/tiktok.svg  ';
const TwitterWhite = '/assets/svg/x-logo.svg';

export const socialIcons = [
    {
        link: "https://www.facebook.com/Invozio",
        icon: FbWhite,
        ariaLabel: "Visit our Facebook page",
    },
    {
        link: "https://www.linkedin.com/company/invozio/?viewAsMember=true",
        icon: LinkedinWhite,
        ariaLabel: "Visit our LinkedIn page",
    },
    {
        link: "https://www.instagram.com/invozio/?igshid=YmMyMTA2M2Y%3D",
        icon: InstagramWhite,
        ariaLabel: "Visit our Instagram page",
    },
    {
        link: "https://www.tiktok.com/@invozio?lang",
        icon: TikTokWhite,
        ariaLabel: "Visit our Tiktok page",
    },
];

export const shareOnSocialMedia = [
    {
        platform: 'facebook',
        icon: FbWhite,
        ariaLabel: "Visit our Facebook page",
    },
    {
        platform: 'linkedin',
        icon: LinkedinWhite,
        ariaLabel: "Visit our LinkedIn page",
    },
    {
        platform: 'twitter',
        icon: TwitterWhite,
        ariaLabel: "Visit our Twitter page",
    },
    // {
    //     platform: 'instagram',
    //     icon: InstagramWhite,
    //     ariaLabel: "Visit our Instagram page",
    // },
    // {
    //     link: "https://www.tiktok.com/@invozio?lang",
    //     icon: TikTokWhite,
    //     ariaLabel: "Visit our Tiktok page",
    // },
];

export const MenuIcon = [
    {
        link: "https://www.facebook.com/Invozio",
        icon: Fb,
        ariaLabel: "Visit our Facebook page",
    },
    {
        link: "https://www.linkedin.com/company/invozio/?viewAsMember=true",
        icon: Linkedin,
        ariaLabel: "Visit our LinkedIn page",
    },
    {
        link: "https://www.instagram.com/invozio/?igshid=YmMyMTA2M2Y%3D",
        icon: Instagram,
        ariaLabel: "Visit our Instagram page",
    },
    {
        link: "https://www.tiktok.com/@invozio?lang",
        icon: TikTok,
        ariaLabel: "Visit our Tiktok page",
    },
];